import React from 'react'
import { connect } from 'react-redux'
import GroupDetail from './Components/GroupDetail/GroupDetail'
import {
  getOmkGroupRequest,
  approveOmkGroupRequest,
  approveOmkGroupReset,
  setOmkGroupVerificationRequest,
  setOmkGroupVerificationReset,
  uploadOmkGroupDocumentRequest,
  uploadOmkGroupDocumentReset,
  deleteOmkGroupDocumentRequest,
  deleteOmkGroupDocumentReset,
  getOmkGroupPoliciesRequest,
  approveOmkGroupPoliciesRequest,
  approveOmkGroupPoliciesReset
} from './Redux/actions'

class GroupDetailPage extends React.Component {
  constructor(props) {
    super(props)
    this.approveGroup = this.approveGroup.bind(this)
    this.setVerification = this.setVerification.bind(this)
    this.resetApprove = this.resetApprove.bind(this)
    this.resetVerification = this.resetVerification.bind(this)
    this.uploadDocument = this.uploadDocument.bind(this)
    this.deleteDocument = this.deleteDocument.bind(this)
    this.resetUploadDocument = this.resetUploadDocument.bind(this)
    this.resetDeleteDocument = this.resetDeleteDocument.bind(this)
    this.getPolicies = this.getPolicies.bind(this)
    this.approvePolicies = this.approvePolicies.bind(this)
    this.resetApprovePolicies = this.resetApprovePolicies.bind(this)
  }

  componentWillMount() {
    const guid = this.props.params && this.props.params.guid
    if (guid) {
      this.props.dispatch(getOmkGroupRequest(guid))
    }
  }

  approveGroup(guid) {
    this.props.dispatch(approveOmkGroupRequest(guid))
  }

  setVerification(payload) {
    this.props.dispatch(setOmkGroupVerificationRequest(payload))
  }

  resetApprove() {
    this.props.dispatch(approveOmkGroupReset())
  }

  resetVerification() {
    this.props.dispatch(setOmkGroupVerificationReset())
  }

  uploadDocument(payload) {
    this.props.dispatch(uploadOmkGroupDocumentRequest(payload))
  }

  deleteDocument(payload) {
    this.props.dispatch(deleteOmkGroupDocumentRequest(payload))
  }

  resetUploadDocument() {
    this.props.dispatch(uploadOmkGroupDocumentReset())
  }

  resetDeleteDocument() {
    this.props.dispatch(deleteOmkGroupDocumentReset())
  }

  getPolicies(payload) {
    this.props.dispatch(getOmkGroupPoliciesRequest(payload))
  }

  approvePolicies(payload) {
    this.props.dispatch(approveOmkGroupPoliciesRequest(payload))
  }

  resetApprovePolicies() {
    this.props.dispatch(approveOmkGroupPoliciesReset())
  }

  render() {
    const data = this.props.omgGroupApprovalData
    return (
      <GroupDetail
        group={data.current_group}
        loader={data.current_group_loader}
        error={data.current_group_error}
        approve_group_loader={data.approve_group_loader}
        approve_group_success={data.approve_group_success}
        approve_group_error={data.approve_group_error}
        set_verification_loader={data.set_verification_loader}
        set_verification_success={data.set_verification_success}
        set_verification_error={data.set_verification_error}
        upload_document_loader={data.upload_document_loader}
        upload_document_success={data.upload_document_success}
        upload_document_error={data.upload_document_error}
        delete_document_loader={data.delete_document_loader}
        delete_document_success={data.delete_document_success}
        delete_document_error={data.delete_document_error}
        approveGroup={this.approveGroup}
        setVerification={this.setVerification}
        resetApprove={this.resetApprove}
        resetVerification={this.resetVerification}
        uploadDocument={this.uploadDocument}
        deleteDocument={this.deleteDocument}
        resetUploadDocument={this.resetUploadDocument}
        resetDeleteDocument={this.resetDeleteDocument}
        group_policies={data.group_policies}
        group_policies_total={data.group_policies_total}
        group_policies_page={data.group_policies_page}
        group_policies_limit={data.group_policies_limit}
        group_policies_loader={data.group_policies_loader}
        group_policies_error={data.group_policies_error}
        approve_policies_loader={data.approve_policies_loader}
        approve_policies_success={data.approve_policies_success}
        approve_policies_error={data.approve_policies_error}
        approve_policies_total={data.approve_policies_total}
        approve_policies_results={data.approve_policies_results}
        approve_policies_decision={data.approve_policies_decision}
        issue_policies_state={data.issue_policies_state}
        issue_policies_queued={data.issue_policies_queued}
        issue_policies_skipped={data.issue_policies_skipped}
        issue_policies_error={data.issue_policies_error}
        getPolicies={this.getPolicies}
        approvePolicies={this.approvePolicies}
        resetApprovePolicies={this.resetApprovePolicies}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    omgGroupApprovalData: state.omgGroupApprovalData
  }
}

export default connect(mapStateToProps)(GroupDetailPage)
